import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 11H7V9H9V11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 13V15H15V13H17Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 9V11H15V9H17Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 21H0V3H24V21ZM7 7C5.89543 7 5 7.89543 5 9V17H7V13H9V17H11V9C11 7.89543 10.1046 7 9 7H7ZM13 7V17H17C18.1046 17 19 16.1046 19 15V9C19 7.89543 18.1046 7 17 7H13Z"}}]};

const TagStateFilled = Vue.extend<IconProps>({
  name: 'TagStateFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tag-state-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TagStateFilled;
